module.exports = __webpack_public_path__ + "img/KEINE-ABBILDUNG.b27aa60c.jpg";